import {Injectable} from '@angular/core';
import {HttpHeaders} from '@angular/common/http';
import {HttpService} from '@core/services';
import {ApiResponse, DashboardMetrics} from '@core/types';
import {ENDPOINTS, GET_URL, log} from '@core/utils';
import {CompanyStateService} from '@core/states';
import {AuthStateService} from '@auth/states';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(
    private apiService: HttpService,
    private companyState: CompanyStateService,
    private authState: AuthStateService
  ) {}

  async getMetrics(): Promise<ApiResponse<DashboardMetrics>> {
    try {
      const url = GET_URL(ENDPOINTS.DASHBOARD_METRICS);
      const headers = this.buildHeaders();
      const response = await this.apiService.get<DashboardMetrics>(url, headers ? {headers} : undefined);
      return {success: true, result: response};
    } catch (error: any) {
      log.error('Error loading dashboard metrics:', error);
    }
    return {
      success: false,
      message: 'No se pudieron cargar las metricas del dashboard.'
    };
  }

  private buildHeaders(): HttpHeaders | null {
    if (this.authState.isAdmin()) {
      return null;
    }

    const membership = this.companyState.membership();
    const companyId = membership?.company?.id;
    if (!companyId) {
      return null;
    }

    return new HttpHeaders().set('X-Selected-Company-ID', String(companyId));
  }
}
